import Container from '../../components/Container';
import { Card } from 'antd';
import UserLogTable from '../../components/users/userDetail/UserLogTable';

/**
 * Display Users Logs
 * /dashboard/admin/log
 */
const UserLogs = () => {
  return (
    <Container>
      <Card>
        <UserLogTable />
      </Card>
    </Container>
  );
};
export default UserLogs;
